import React from 'react';
import Layout from '../components/Layout';
import { Shield, Lock, Eye, Database, UserCheck } from 'lucide-react';

const Datenschutz = ({ user }) => {
  return (
    <Layout user={user}>
      <div className="max-w-4xl mx-auto p-4 md:p-8">
        <div className="bg-white rounded-lg shadow-sm border" style={{borderColor: '#E1E4E8'}}>
          <div className="p-6 md:p-8">
            <h1 className="text-3xl font-bold text-gray-900 mb-2 flex items-center gap-3">
              <Shield className="w-8 h-8 text-blue-600" />
              Datenschutzerklärung
            </h1>
            <p className="text-sm text-gray-600 mb-6">Stand: Dezember 2024</p>
            
            <div className="space-y-6">
              <div>
                <h2 className="text-xl font-semibold text-gray-900 mb-3">1. Datenschutz auf einen Blick</h2>
                <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-4">
                  <h3 className="font-semibold text-blue-900 mb-2">Allgemeine Hinweise</h3>
                  <p className="text-sm text-blue-800">Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren personenbezogenen Daten passiert, wenn Sie diese Software nutzen. Personenbezogene Daten sind alle Daten, mit denen Sie persönlich identifiziert werden können.</p>
                </div>
              </div>

              <div className="border-t pt-6" style={{borderColor: '#E1E4E8'}}>
                <h2 className="text-xl font-semibold text-gray-900 mb-3 flex items-center gap-2">
                  <Database className="w-5 h-5 text-blue-600" />
                  2. Datenerfassung in Easyclaim24
                </h2>
                <div className="space-y-4 text-gray-700">
                  <div>
                    <h3 className="font-semibold mb-2">Wer ist verantwortlich für die Datenerfassung?</h3>
                    <p className="text-sm">Die Datenverarbeitung in dieser Software erfolgt durch den Softwarebetreiber. Dessen Kontaktdaten können Sie dem Impressum entnehmen.</p>
                  </div>
                  <div>
                    <h3 className="font-semibold mb-2">Wie erfassen wir Ihre Daten?</h3>
                    <p className="text-sm mb-2">Ihre Daten werden zum einen dadurch erhoben, dass Sie uns diese mitteilen. Hierbei kann es sich z.B. um Daten handeln, die Sie in ein Kontaktformular eingeben.</p>
                    <p className="text-sm">Andere Daten werden automatisch beim Nutzen der Software durch unsere IT-Systeme erfasst. Das sind vor allem technische Daten (z.B. Browsertyp, Betriebssystem oder Uhrzeit des Seitenaufrufs).</p>
                  </div>
                  <div>
                    <h3 className="font-semibold mb-2">Wofür nutzen wir Ihre Daten?</h3>
                    <p className="text-sm">Ein Teil der Daten wird erhoben, um eine fehlerfreie Bereitstellung der Software zu gewährleisten. Andere Daten können zur Analyse Ihres Nutzerverhaltens verwendet werden.</p>
                  </div>
                </div>
              </div>

              <div className="border-t pt-6" style={{borderColor: '#E1E4E8'}}>
                <h2 className="text-xl font-semibold text-gray-900 mb-3 flex items-center gap-2">
                  <UserCheck className="w-5 h-5 text-blue-600" />
                  3. Welche Rechte haben Sie bezüglich Ihrer Daten?
                </h2>
                <div className="space-y-3 text-gray-700">
                  <div className="bg-gray-50 p-4 rounded-lg">
                    <h3 className="font-semibold mb-2">✓ Auskunftsrecht</h3>
                    <p className="text-sm">Sie haben jederzeit das Recht, unentgeltlich Auskunft über Herkunft, Empfänger und Zweck Ihrer gespeicherten personenbezogenen Daten zu erhalten.</p>
                  </div>
                  <div className="bg-gray-50 p-4 rounded-lg">
                    <h3 className="font-semibold mb-2">✓ Berichtigungsrecht</h3>
                    <p className="text-sm">Sie haben das Recht, die Berichtigung oder Vervollständigung unrichtiger bzw. unvollständiger personenbezogener Daten zu verlangen.</p>
                  </div>
                  <div className="bg-gray-50 p-4 rounded-lg">
                    <h3 className="font-semibold mb-2">✓ Löschungsrecht</h3>
                    <p className="text-sm">Sie haben das Recht, die Löschung Ihrer personenbezogenen Daten zu verlangen, sofern keine gesetzlichen Aufbewahrungspflichten bestehen.</p>
                  </div>
                  <div className="bg-gray-50 p-4 rounded-lg">
                    <h3 className="font-semibold mb-2">✓ Widerspruchsrecht</h3>
                    <p className="text-sm">Sie haben das Recht, der Verarbeitung Ihrer personenbezogenen Daten zu widersprechen.</p>
                  </div>
                  <div className="bg-gray-50 p-4 rounded-lg">
                    <h3 className="font-semibold mb-2">✓ Beschwerderecht</h3>
                    <p className="text-sm">Sie haben das Recht, sich bei einer Datenschutz-Aufsichtsbehörde zu beschweren.</p>
                  </div>
                </div>
              </div>

              <div className="border-t pt-6" style={{borderColor: '#E1E4E8'}}>
                <h2 className="text-xl font-semibold text-gray-900 mb-3 flex items-center gap-2">
                  <Lock className="w-5 h-5 text-blue-600" />
                  4. Datenverarbeitung in Easyclaim24
                </h2>
                <div className="space-y-4 text-gray-700">
                  <div>
                    <h3 className="font-semibold mb-2">Kundendaten</h3>
                    <p className="text-sm">Wir verarbeiten Kundendaten (Name, Adresse, Kontaktdaten, Fahrzeugdaten) zur Erfüllung unserer vertraglichen Pflichten und zur Bearbeitung von Schadenfällen.</p>
                  </div>
                  <div>
                    <h3 className="font-semibold mb-2">Versicherungsdaten</h3>
                    <p className="text-sm">Versicherungsinformationen werden ausschließlich zur Abwicklung von Schadenfällen und zur Kommunikation mit Versicherungen verwendet.</p>
                  </div>
                  <div>
                    <h3 className="font-semibold mb-2">Fotos und Dokumente</h3>
                    <p className="text-sm">Schadensfotos und hochgeladene Dokumente werden sicher auf unseren Servern gespeichert und nur für die Schadenbearbeitung verwendet.</p>
                  </div>
                  <div>
                    <h3 className="font-semibold mb-2">Chat-Daten</h3>
                    <p className="text-sm">Nachrichten im Support-Chat werden zur Verbesserung unseres Services gespeichert. Diese Daten werden nicht an Dritte weitergegeben.</p>
                  </div>
                </div>
              </div>

              <div className="border-t pt-6" style={{borderColor: '#E1E4E8'}}>
                <h2 className="text-xl font-semibold text-gray-900 mb-3 flex items-center gap-2">
                  <Eye className="w-5 h-5 text-blue-600" />
                  5. Datensicherheit
                </h2>
                <p className="text-gray-700 text-sm mb-3">Wir verwenden geeignete technische und organisatorische Sicherheitsmaßnahmen, um Ihre Daten gegen zufällige oder vorsätzliche Manipulationen, Verlust, Zerstörung oder den Zugriff unberechtigter Personen zu schützen.</p>
                <div className="bg-green-50 border border-green-200 rounded-lg p-4">
                  <div className="space-y-2 text-sm text-green-800">
                    <p>✓ SSL/TLS-Verschlüsselung für Datenübertragung</p>
                    <p>✓ Verschlüsselte Datenspeicherung</p>
                    <p>✓ Regelmäßige Sicherheitsupdates</p>
                    <p>✓ Zugriffskontrollen und Berechtigungsmanagement</p>
                    <p>✓ Regelmäßige Backups</p>
                  </div>
                </div>
              </div>

              <div className="border-t pt-6" style={{borderColor: '#E1E4E8'}}>
                <h2 className="text-xl font-semibold text-gray-900 mb-3">6. Kontakt zum Datenschutzbeauftragten</h2>
                <div className="bg-gray-50 p-4 rounded-lg">
                  <p className="text-gray-700 text-sm mb-2">Bei Fragen zum Datenschutz erreichen Sie uns unter:</p>
                  <p className="text-gray-900 font-medium">datenschutz@easyclaim24.de</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Datenschutz;
